export default __webpack_public_path__ + "static/media/logo.bb803ba1.svg";